'use strict';

const Backbone = require('backbone');
const Moment = require('moment');
const Key = require('common/domain/value/key');
const ProjectMemberCollection = require('common/domain/collection/project-member');

class ProjectStatus extends Backbone.Model {
    constructor(params) {
        super(params);
        this._members = new ProjectMemberCollection();
        this._membersWithSuspended = new ProjectMemberCollection();
        this._updateMembers();
        this.on('change:members', this._updateMembers);
    }

    _updateMembers() {
        this._membersWithSuspended.set(this.get('members'));
        this._members.set(this._membersWithSuspended.filter(m => !m.isSuspended()));
    }

    getName() {
        return this.get('name');
    }

    getMembers(options = null) {
        if (options && options.withSuspended) {
            return this._membersWithSuspended;
        }
        return this._members;
    }

    isMember(user) {
        return user ? this.getMembers().getMemberByUser(user.id) != null : false;
    }

    getProjectKey() {
        return new Key(this.get('projectKey'));
    }

    getGroupName() {
        return new Key(this.get('groupName'));
    }

    getGroupKey() {
        return new Key(this.get('groupKey'));
    }

    getImageURL() {
        return this.get('imageURL');
    }

    path() {
        const projectKey = this.getProjectKey();
        return `/projects/${projectKey.id}`;
    }

    getGroupURL() {
        const groupKey = this.getGroupKey();
        return `/groups/${groupKey.id}`;
    }

    getEndAt() {
        return this.get('endAt');
    }

    getStartAt() {
        return this.get('startAt');
    }

    getUpdatedAt() {
        return this.get('updatedAt');
    }

    getStateType() {
        return this.get('stateType');
    }

    getStateName() {
        return this.get('stateName');
    }

    getActionInitialStateCount() {
        return this.get('action').initialStateCount;
    }

    getActionNormalStateCount() {
        return this.get('action').normalStateCount;
    }

    getActionFinalStateCount() {
        return this.get('action').finalStateCount;
    }

    getActionTerminatedStateCount() {
        return this.get('action').terminatedStateCount;
    }

    getActionTotalActionCount() {
        return this.getActionInitialStateCount() + this.getActionNormalStateCount() + this.getActionFinalStateCount();
    }

    getFirstStartAtOfActionsNotStarted() {
        return this.get('action').firstStartAtOfActionsNotStarted;
    }

    getStartLastDaysOfActionsNotStarted() {
        const today = Moment();
        const firstStartAt = this.getFirstStartAtOfActionsNotStarted();

        let startLastDays;
        if(firstStartAt) {
            startLastDays = Moment(firstStartAt).diff(today, 'days');
        }
        return startLastDays;
    }

    // プロジェクトに開始日までに開始していないアクションがある（状態が未着手である & 開始日を過ぎている）
    hasNotStartedActions() {
        return this.getStartLastDaysOfActionsNotStarted() < 0;
    }

    getFirstEndAtOfActionsNotEnded() {
        return this.get('action').firstEndAtOfActionsNotEnded;
    }

    getEndLastDaysOfActionsNotEnded() {
        const today = Moment();
        const firstEndAt = this.getFirstEndAtOfActionsNotEnded();

        let endLastDays;
        if(firstEndAt) {
            endLastDays = Moment(firstEndAt).diff(today, 'days');
        }
        return endLastDays;
    }

    // プロジェクトに終了日までに完了/キャンセルしていないアクションがある（状態が完了/キャンセルでない & 終了日を過ぎている）
    hasNotEndedActions() {
        return this.getEndLastDaysOfActionsNotEnded() < 0;
    }

    hasDelayedActions() {
        return this.hasNotStartedActions() || this.hasNotEndedActions();
    }
}

module.exports = ProjectStatus;



// WEBPACK FOOTER //
// ./common/domain/entity/project-status.js